import useOnlyDevelopers from 'state/setOnlyDevelopers';
import ChargerModule from '../../../components/chargerModule';
import BulkUploadCard from './components/BulkUploadCard/BulkUploadCard';
import TypeOfChargeInfo from './components/TypeOfChargeInfo/TypeOfChargeInfo';
import UploadHistory from './components/UploadHistory/UploadHistory';
import { BULK_UPLOAD_CARDS } from './constants';
import './TypeOfCharge.scss';

const TypeOfCharge = () => {
  const { isOnlyDevsAutomates } = useOnlyDevelopers();

  const filteredCards = BULK_UPLOAD_CARDS.filter(card => {
    if (card?.isOnlyDevsAutomates) {
      return isOnlyDevsAutomates;
    }
    return true;
  });

  return (
    <ChargerModule
      headerInfo={{
        title: 'Cargue Masivo',
        subtitle: '',
        titleRoute: '/bulk-upload/type-of-charge'
      }}
      infoSideBar={{ position: 'bulkUpload' }}
    >
      <section className="typeOfCharge">
        <TypeOfChargeInfo
          title={'Tipo de cargue masivo'}
          description={
            <>
              Gestiona información de forma masiva con plantillas de <strong>Excel o Google Sheets</strong>
            </>
          }
        />
        <section className={`typeOfChargeCards ${isOnlyDevsAutomates ? 'threeCards' : ''}`}>
          {filteredCards.map((card, index) => (
            <BulkUploadCard key={`typeOfChargeCards-${index}`} {...card} />
          ))}
        </section>
        <section className="typeOfChargeHistory">
          <UploadHistory />
        </section>
      </section>
    </ChargerModule>
  );
};

export default TypeOfCharge;
